import {
  Control,
  Controller,
  FieldValues,
  Path,
  PathValue,
  UseFormSetValue,
  UseFormTrigger,
  useController,
} from 'react-hook-form';
import { CountrySelect } from '../form/locationDropdowns';
import { useEffect, useState } from 'react';

const FormCountryAutocomplete = <R extends FieldValues>({
  name,
  control,
  setValue,
  fieldsToClear,
  trigger,
}: {
  name: Path<R>;
  control: Control<R>;
  setValue: UseFormSetValue<R>;
  fieldsToClear: Path<R>[];
  trigger: UseFormTrigger<R>;
}) => {
  const {
    fieldState: { isTouched },
  } = useController({ name, control });

  const onChange = (newValue: string) => {
    setValue(name, newValue as PathValue<R, Path<R>>);
    if (isTouched) trigger(name, { shouldFocus: true });
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onBlur, value }, fieldState: { error } }) => (
        <CountrySelect value={value} onBlur={onBlur} onChange={onChange} error={!!error} />
      )}
    />
  );
};

export default FormCountryAutocomplete;
